module.exports = __webpack_public_path__ + "static/media/17.9cbb72da.svg";